export function commaSeparate(list) {
    if (list === undefined || list === null || list.length === 0 || list.typeOf !== undefined) {
        return '--';
    }

    if (list.typeOf == undefined) {
        return list;
    }
    return list.join(', ');
}
